export default __webpack_public_path__ + "static/media/PlaymaticsLLC.382f6928.png";